import * as PATHS from 'constants/app-paths'
import {
  PRODUCTS_SUBMENU,
} from './submenus'

const MAIN_MENU = {
  dashboard: {
    label: 'Dashboard',
    link: PATHS.DASHBOARD,
    submenu: null,
    pathnames: [],
    exact: true,
  },
  sales: {
    label: 'Vendas',
    link: PATHS.ORDERS,
    submenu: null,
    pathnames: ['/vendas'],
    exact: false,
  },
  product: {
    label: 'Produtos',
    link: PATHS.PRODUCTS,
    submenu: PRODUCTS_SUBMENU,
    pathnames: ['/produtos', '/fabricantes', '/categorias', '/grupos'],
    exact: false,
  },
  customer: {
    label: 'Clientes',
    link: PATHS.CUSTOMERS,
    submenu: null,
    pathnames: ['/clientes'],
    exact: false,
  },
  settings: {
    label: 'Administração',
    link: PATHS.SALES_CHANNELS,
    submenu: null,
    pathnames: ['/configuracoes', '/relatorios/diario'],
    exact: false,
  },
}

export const activeMainMenu = (match, location, area) => {
  if (match) return true

  const menu = MAIN_MENU[area]
  return menu?.pathnames.includes(location.pathname)
}

export default MAIN_MENU
